import { graphql, formatPageQuery, formatMutation, decodeId } from "@openimis/fe-core";
import _ from "lodash";
import _uuid from "lodash-uuid";
import { v4 as uuidv4 } from "uuid";

export function fetchAccreditationUsers(filter) {
  let projections = ["id", "username", "otherNames", "lastName"];
  const payload = formatPageQuery("users", [`username_Icontains:"${filter}"`], projections);
  return graphql(payload, "FETCH_ACCREDITATION_USERS");
}

export function fetchQAUsers(filter) {
  let projections = ["id", "username", "otherNames", "lastName"];
  const payload = formatPageQuery("users", [`username_Icontains:"${filter}"`], projections);
  return graphql(payload, "FETCH_QA_USERS");
}

function formatUUIDArrays(uuidsArray) {
  return `[${uuidsArray.map((uuid) => `"${uuid}"`).join(", ")}]`;
}

export function fetchAccreditationProjects(filters) {
  let projections = ["uuid", "projectName", "healthFacility{name, uuid}", "createdDate", "status"];
  const payload = formatPageQuery("accreditationProjects", filters, projections);
  return graphql(payload, "ACCREDITATION_ACCREDITATION_PROJECTS");
}

export function fetchAccreditation(uuid) {
  const payload = `
  query {
      accreditationProjects(uuid:"${uuid}"){
          edges{
          node{
          uuid, projectName, healthFacility{code,name,uuid}, createdDate, status,id
          }
          }
      }
  }
  `;
  return graphql(payload, "ACCREDITATION_ACCREDITATION");
}

export function fetchHfAccreditations(projectId, filters) {
  const payload = `
    query {
        accreditationDetails(project:"${projectId}", ${filters ? filters : ""}){
          edges{
            node{
              uuid,
              state,
              status,
              created,
              comments,
              projectName,
              isInitialized
            }
          }
    }
}
  `;
  return graphql(payload, "ACCREDITATION_ACCREDITATION_DETAILS");
}

export function fetchAccreditationDetail(uuid) {
  const payload = `
    {
  accreditationDetails(uuid:"${uuid}"){
    edges{  
    node{ 
      isInitialized,
      uuid,
      created,
      status,
      state,
      id,
      projectName,
      project{
        projectName
      }
    }
    }
  }
}
  `;
  return graphql(payload, "ACCREDITATION_ACCREDITATION_DETAIL");
}

export function fetchForms(formType) {
  const payload = `
     {
  odkForms(formType:${formType}){
    edges{
      node{
        formName,
        uuid
      }
    }
  }
}
  `;
  return graphql(payload, "ACCREDITATION_PROJECT_FORMS");
}

export function fetchAllForms() {
  const payload = `
     {
  odkForms{
    edges{
      node{
        uuid
        formName
        formType
        createdDate
        isValid
        odkformconfig{
          calculationParameters
          createdDate
          updatedDate
        }
      }
    }
  }
}
  `;
  return graphql(payload, "ALL_PROJECT_FORMS");
}

export function fetchAccreditationFormCalculation(accreditationDetailFormUuid, odkInstanceId) {
  const payload = `
    {
      accreditationFormCalculation(accreditationDetailFormUuid: ${accreditationDetailFormUuid}, odkInstanceId: ${odkInstanceId}) {
        data
      }
    }
  `;
  return graphql(payload, "ACCREDITATION_DETAILS_FORMS");
}

export function fetchAccreditationDetailForms(uuid) {
  const id = uuid;
  const payload = `
     {
  accreditationDetailForms(accreditationDetail:"${id}"){
    edges{
      node{
        uuid,
        submitedData,
        odkForm{
          formName, 
          uuid,
          id
        }
      }
    }
  }
}
  `;

  return graphql(payload, "ACCREDITATION_DETAILS_FORMS");
}

// export function fetchAccreditationDetailFormData(uuid, type) {
//   const payload = `{
//    projectDetailFormData(projectDetailType:"${type}", projectDetailFormUuid:"${uuid}"){
//     data
// }}
//   `;
//   return graphql(payload, "ACCREDITATION_DETAILS_FORMDATA");
// }
export function fetchAccreditationDetailFormData(uuid, type) {
  const payload = `{
   projectDetailFormData(projectDetailType:"${type}", projectDetailFormUuid:"${uuid}"){
    data
   }
  }`;
  return graphql(payload, "ACCREDITATION_DETAILS_FORMDATA");
}

// export function fetchquality_assurance_and_accreditationFormCalculation(quality_assurance_and_accreditationDetailFormUuid, odkInstanceId) {
//   const payload = `
//   {
//     quality_assurance_and_accreditationFormCalculation(quality_assurance_and_accreditationDetailFormUuid: ${quality_assurance_and_accreditationDetailFormUuid}, odkInstanceId: ${odkInstanceId}) {
//       data
//     }
//   }
//   `;

//   return graphql(payload, "ACCREDITATION_FORM_CALCULATION");
// }

export function formatProjectGQL(project) {
  return `
    ${project.healthFacility ? `healthFacility: "${project.healthFacility.uuid}"` : ""}
    ${!!project.projectName ? `projectName: "${project.projectName}"` : ""}
  `;
}

export function fetchQualityAssuranceProjects(filters) {
  let projections = ["uuid", "name", "healthFacility{name, uuid}", "createdDate"];
  const payload = formatPageQuery("qualityAssurancies", "", projections);

  return graphql(payload, "ACCREDITATION_QUALITY_ASSURANCE_PROJECTS");
}

export function fetchOdkUser(detailUuid, projectType) {
  const filterField = projectType === "qa" ? "qaProjectDetail_Uuid" : "accProjectDetail_Uuid";

  // Choose the right project detail field for query results
  const projectDetailField = projectType === "QA" ? "qaProjectDetail" : "accProjectDetail";

  const payload = `
    {
      odkUsers(${filterField}:"${detailUuid}") {
        edges {
          node {
            userPurpose
            qrCodeJson
            uuid
            ${projectDetailField} {
              uuid
            }
            user {
              username
              lastName
              otherNames
            }
          }
        }
      }
    }
  `;

  return graphql(payload, "ODK_USERS");
}

export function fetchQualityAssurance(uuid) {
  const payload = `
   {
  qualityAssurancies(uuid:"${uuid}"){
    edges{
      node{
        name,
        uuid,
        id,
        status
        createdDate
        healthFacility{
          name
          code
        }
      }
    }
  }
}
  `;

  return graphql(payload, "QUALITY_ASSURANCE");
}

export function fetchHfQualityAssurancies(prjId) {
  const payload = `
      {
  qualityAssuranceDetails(qualityAssurance:"${prjId}"){
    edges{
      node{
        projectName,
        uuid,
        state,
        status ,
        createdDate     
      }
}
}
}
  `;
  return graphql(payload, "HF_QUALITY_ASSURANCE");
}

export function fetchQualityAssuranceDetail(uuid) {
  const payload = `
      {
  qualityAssuranceDetails(uuid:"${uuid}"){
    edges{
      node{
        projectName,
        uuid,
        state,
        id
        status  
        createdDate
        isInitialized    
      }
}
}
}
  `;
  return graphql(payload, "QUALITY_ASSURANCE_DETAIL");
}

export function fetchUserQrCode(uuid) {
  const payload = `
     {
 odkUserQrCodeUri(odkUserUuid:"${uuid}"){
  qrCodeUri
}
}
  `;

  return graphql(payload, "FETCH_QRCODE");
}

export function fetchQADetailForms(id) {
  const qaId = decodeId(id);
  console.log("Decoded QA ID:", qaId);

  const payload = `{ 
      qualityAssuranceDetailForms(projectDetail_Id:"${qaId}"){
         edges{
           node{
            uuid,
            submitedData,
            odkForm{
              formName,
              uuid,
              id
            }
      }
}
  }
  }`;

  return graphql(payload, "QA_DETAILS_FORMS");
}

export const APPROVE_DETAIL_FORM_REQ = "APPROVE_DETAIL_FORM_REQ";
export const APPROVE_DETAIL_FORM_RESP = "APPROVE_DETAIL_FORM_RESP";
export const APPROVE_DETAIL_FORM_ERR = "APPROVE_DETAIL_FORM_ERR";

export const approveDetailForm = (formUuid, detailType, clientMutationLabel = "Approve Detail Form") => {
  const mutation = `
    mutation {
      approveDetailFormDataEntry(input: {
        detailFormUuid: "${formUuid}"
        detailType: ${detailType}
        clientMutationId: "${clientMutationLabel}"
      }) {
        internalId
        clientMutationId
      }
    }
  `;

  return graphql(mutation.payload, [APPROVE_DETAIL_FORM_REQ, APPROVE_DETAIL_FORM_RESP, APPROVE_DETAIL_FORM_ERR], {
    clientMutationLabel,
    clientMutationId: clientMutationLabel,
    type: "mutation",
  });
};

export const createAccreditationProject = (project, clientMutationLabel) => {
  const mutation = formatMutation("createAccreditationProject", formatProjectGQL(project), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(
    mutation.payload,
    ["ACCREDITATION_MUTATION_REQ", "ACCREDITATION_CREATE_ACCREDITATION_PROJECTS_RESP", "ACCREDITATION_MUTATION_ERR"],
    {
      clientMutationId: mutation.clientMutationId,
      clientMutationLabel,
      requestedDateTime,
    },
  );
};

export const uploadOdkForm = (form, clientMutationLabel) => {
  const mutation = formatMutation(
    "uploadOdkForm",
    `file:"${form?.form?.file}" formName:"${form?.form?.fileName}"  formType:"${form.formType}"`,
    clientMutationLabel,
  );
  var requestedDateTime = new Date();
  return graphql(
    mutation.payload,
    ["ACCREDITATION_MUTATION_REQ", "ACCREDITATION_UPLOAD_ODK_FORM_RESP", "ACCREDITATION_MUTATION_ERR"],
    {
      clientMutationId: mutation.clientMutationId,
      clientMutationLabel,
      requestedDateTime,
    },
  );
};

export const initiateAccreditation = (projectUuid, clientMutationLabel) => {
  const mutation = formatMutation(
    "createAccreditationDetail",
    `accreditationProjectUuid:"${projectUuid}"`,
    clientMutationLabel,
  );
  var requestedDateTime = new Date();
  return graphql(
    mutation.payload,
    ["ACCREDITATION_MUTATION_REQ", "CREATE_ACCREDITATION_DETAIL_RESP", "ACCREDITATION_MUTATION_ERR"],
    {
      clientMutationId: mutation.clientMutationId,
      clientMutationLabel,
      requestedDateTime,
    },
  );
};

export function deployForms(forms, accDetailUuid, detailType, clientMutationLabel) {
  const formattedForms = formatUUIDArrays(forms);

  const mutation = formatMutation(
    "deployOdkForms",
    `
      odkFormUuids:${formattedForms}
      detailUuid:"${accDetailUuid}"
      detailType:"${detailType}"
    `,
    clientMutationLabel,
  );

  var requestedDateTime = new Date();
  return graphql(
    mutation.payload,
    ["ACCREDITATION_MUTATION_REQ", "DEPLOY_ACCREDITATION_DETAIL_FORM_RESP", "ACCREDITATION_MUTATION_ERR"],
    {
      clientMutationId: mutation.clientMutationId,
      clientMutationLabel,
      requestedDateTime,
    },
  );
}

export function initiateAccreditationDetail(uuid, clientMutationLabel) {
  const mutation = formatMutation(
    "initiateAccreditationDetail",
    `accreditationDetailUuid:"${uuid}"`,
    clientMutationLabel,
  );
  var requestedDateTime = new Date();
  return graphql(
    mutation.payload,
    ["ACCREDITATION_MUTATION_REQ", "INITIATE_ACCREDITATION_DETAIL_RESP", "ACCREDITATION_MUTATION_ERR"],
    {
      clientMutationId: mutation.clientMutationId,
      clientMutationLabel,
      requestedDateTime,
    },
  );
}

export function initiateQADetail(uuid, clientMutationLabel) {
  const mutation = formatMutation(
    "initiateQualityAssuranceDetail",
    `qualityAssuranceDetailUuid:"${uuid}"`,
    clientMutationLabel,
  );
  var requestedDateTime = new Date();
  return graphql(
    mutation.payload,
    ["ACCREDITATION_MUTATION_REQ", "INITIATE_QA_DETAIL_RESP", "ACCREDITATION_MUTATION_ERR"],
    {
      clientMutationId: mutation.clientMutationId,
      clientMutationLabel,
      requestedDateTime,
    },
  );
}
export function approveOrDeclineAccreditationDetail(payload) {
  const declineTypePart = payload.status === "DC" && payload.declineType ? `declineType:"${payload.declineType}"` : "";

  const declineReasonPart =
    payload.status === "DC" && payload.declineReason ? `declineReason:"${payload.declineReason}"` : "";

  const commentsPart = payload.comments ? `comments:"${payload.comments}"` : "";

  const mutation = formatMutation(
    "approveOrDeclineAccreditationDetail",
    `accreditationDetailUuid:"${payload.uuids[0]}"
     accreditationState:"${payload.status}"
     ${declineTypePart}
     ${declineReasonPart}
     ${commentsPart}`,
    payload.clientMutationLabel,
  );

  var requestedDateTime = new Date();

  // Calling the GraphQL API
  return graphql(
    mutation.payload,
    ["ACCREDITATION_MUTATION_REQ", "APPROVE_OR_DECLINE_ACCREDITATION_DETAIL_RESP", "ACCREDITATION_MUTATION_ERR"],
    {
      clientMutationId: mutation.clientMutationId,
      clientMutationLabel: payload.clientMutationLabel,
      requestedDateTime,
    },
  );
}
export function approveOrQADetail(qaObj, state, clientMutationLabel) {
  const uuid = typeof qaObj === "string" ? qaObj : qaObj?.uuids?.[0];
  const safeState = state || qaObj?.status || "";
  const safeLabel = clientMutationLabel || qaObj?.comments || "";

  const mutation = formatMutation(
    "approveOrDeclineQualityAssuranceDetail",
    `qualityAssuranceDetailUuid: "${uuid}"
     qualitationAssuranceState: "${safeState}"
    `,
    safeLabel,
  );

  const requestedDateTime = new Date();
  return graphql(
    mutation.payload,
    ["ACCREDITATION_MUTATION_REQ", "APPROVE_OR_DECLINE_QA_DETAIL_RESP", "ACCREDITATION_MUTATION_ERR"],
    {
      clientMutationId: mutation.clientMutationId,
      clientMutationLabel: safeLabel,
      requestedDateTime,
    },
  );
}

export const createQAProject = (hf, clientMutationLabel) => {
  const mutation = formatMutation(
    "createQualityAssuranceProject",
    `healthFacilityUuid:"${hf.uuid}"`,
    clientMutationLabel,
  );
  var requestedDateTime = new Date();
  return graphql(
    mutation.payload,
    ["ACCREDITATION_MUTATION_REQ", "ACCREDITATION_CREATE_QA_PROJECTS_RESP", "ACCREDITATION_MUTATION_ERR"],
    {
      clientMutationId: mutation.clientMutationId,
      clientMutationLabel,
      requestedDateTime,
    },
  );
};

export function createQualityAssuranceDetail(qualityAsssuranceProjectUuid, clientMutationLabel) {
  const mutation = formatMutation(
    "createQualityAssuranceDetail",
    `qualityAssuranceProjectUuid:"${qualityAsssuranceProjectUuid}"`,
    clientMutationLabel,
  );
  var requestedDateTime = new Date();

  return graphql(
    mutation.payload,
    ["ACCREDITATION_MUTATION_REQ", "CREATE_QUALITY_ASSURANCE_DETAIL_RESP", "ACCREDITATION_MUTATION_ERR"],
    {
      clientMutationId: mutation.clientMutationId,
      clientMutationLabel,
      requestedDateTime,
    },
  );
}

export function createODKUser(userId, projectType, projectUuid, clientMutationLabel) {
  const mutation = formatMutation(
    "createOdkUser",
    `userId:"${decodeId(
      userId,
    )}", appUserPurpose:"${projectType}", detailProjectUuid:"${projectUuid}"  projectDetailType:"${projectType}"`,
    clientMutationLabel,
  );

  var requestedDateTime = new Date();

  return graphql(
    mutation.payload,
    ["ACCREDITATION_MUTATION_REQ", "CREATE_ODK_USER_RESP", "ACCREDITATION_MUTATION_ERR"],
    {
      clientMutationId: mutation.clientMutationId,
      clientMutationLabel,
      requestedDateTime,
    },
  );
}

export function assignFormsToOdkUser(
  formList,
  projectDetailUuid,
  odkUserUuid,
  projectDetailType,
  methodType,
  clientMutationLabel = "Assign Form to User",
) {
  const formattedForms = formatUUIDArrays(formList);
  console.log("Forms being assigned:", formList);

  const mutation = formatMutation(
    "assignOrUnassignOdkUser",
    `odkFormUuids:${formattedForms}, projectDetailType:"${projectDetailType}",odkUserUuid:"${odkUserUuid}",projectDetailUuid:"${projectDetailUuid}"`,
    clientMutationLabel,
  );
  var requestedDateTime = new Date();
  return graphql(
    mutation.payload,
    ["ACCREDITATION_MUTATION_REQ", "ASSIGN_FORMS_TO_ODK_USER_RESP", "ACCREDITATION_MUTATION_ERR"],
    {
      clientMutationId: mutation.clientMutationId,
      clientMutationLabel,
      requestedDateTime,
    },
  );
}
export function UnassignFormsToOdkUser(
  formList,
  projectDetailUuid,
  odkUserUuid,
  projectDetailType,
  methodType,
  clientMutationLabel = "Unassign Form from User",
) {
  const formattedForms = formatUUIDArrays(formList);
  const mutation = formatMutation(
    "assignOrUnassignOdkUser",
    `odkFormUuids:${formattedForms}, projectDetailType:"${projectDetailType}",odkUserUuid:"${odkUserUuid}",projectDetailUuid:"${projectDetailUuid}"`,
    clientMutationLabel,
  );
  var requestedDateTime = new Date();
  return graphql(
    mutation.payload,
    ["ACCREDITATION_MUTATION_REQ", "UNASSIGN_FORMS_TO_ODK_USER_RESP", "ACCREDITATION_MUTATION_ERR"],
    {
      clientMutationId: mutation.clientMutationId,
      clientMutationLabel,
      requestedDateTime,
    },
  );
}
export const FORM_VALIDATED = "FORM_VALIDATED";

// export const formValidated = (validatedForm) => {
//   return {
//     type: FORM_VALIDATED,
//     payload: validatedForm, // This should be the form data that is validated
//   };
// };

export function formValidated(detailFormUuid, detailType, clientMutationLabel = "Validate Form") {
  // Create the GraphQL mutation string using formatMutation helper
  const mutation = formatMutation(
    "validateForm", // This should match the GraphQL mutation name
    `
      detailFormUuid: "${detailFormUuid}"
      detailType: ${detailType}
    `,
    clientMutationLabel,
  );

  const requestedDateTime = new Date();

  return graphql(mutation.payload, ["FORM_VALIDATED_REQ", "FORM_VALIDATED_RESP", "FORM_VALIDATED_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel,
    requestedDateTime,
  });
}

export function approveDetailFormDataEntry(detailFormUuid, detailType, clientMutationLabel) {
  const mutation = formatMutation(
    "approveDetailFormDataEntry",
    `
      detailFormUuid: "${detailFormUuid}"
      detailType: "${detailType}"
    `,
    clientMutationLabel,
  );

  const requestedDateTime = new Date();

  return graphql(
    mutation.payload,
    ["APPROVE_DETAIL_FORM_DATA_ENTRY_REQ", "APPROVE_DETAIL_FORM_DATA_ENTRY_RESP", "APPROVE_DETAIL_FORM_DATA_ENTRY_ERR"],
    {
      clientMutationId: mutation.clientMutationId,
      clientMutationLabel,
      requestedDateTime,
    },
  );
}

export function initiateAndDeployForms(formList, detailUuid, clientMutationLabel) {
  const formattedForms = formatUUIDArrays(formList);
  const mutation = formatMutation(
    "bulkInitiateAndDeployOdkForms",
    `odkFormUuids:${formattedForms}, 
    accreditationDetailUuid:"${detailUuid}"`,
    clientMutationLabel,
  );
  var requestedDateTime = new Date();
  return graphql(
    mutation.payload,
    ["ACCREDITATION_MUTATION_REQ", "INITIATE_AND_DEPLOY_FORMS", "ACCREDITATION_MUTATION_ERR"],
    {
      clientMutationId: mutation.clientMutationId,
      clientMutationLabel,
      requestedDateTime,
    },
  );
}

export function createFormConfiguration(calculationParams, odkFormUuid, clientMutationLabel) {
  const mutation = formatMutation(
    "createFormConfiguration",
    `odkFormUuid:${odkFormUuid},
    calculationParams:${calculationParams}`,
    clientMutationLabel,
  );
  var requestedDateTime = new Date();
  return graphql({
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel,
    requestedDateTime,
  });
}

export function startOrStopAcc(data, clientMutationLabel) {
  const mutation = formatMutation(
    "startOrStopAccreditationDetail",
    `accreditationDetailUuid:"${data.uuid}", , action:"${data.action}"`,
    clientMutationLabel,
  );

  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["ACCREDITATION_MUTATION_REQ", "START_OR_STOP_ACC", "ACCREDITATION_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel,
    requestedDateTime,
  });
}

export function startOrStopQA(data, clientMutationLabel) {
  const mutation = formatMutation(
    "startOrStopQualityAssuranceDetail",
    `qualityAssuranceDetailUuid:"${data.uuid}", , action:"${data.action}"`,
    clientMutationLabel,
  );

  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["ACCREDITATION_MUTATION_REQ", "START_OR_STOP_QA", "ACCREDITATION_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel,
    requestedDateTime,
  });
}

export function fetchOdkUserAssignment(filter) {
  let projections = ["uuid", "id"];
  const payload = formatPageQuery("odkUserAssignments", [], projections);

  return graphql(payload, "FETCH_ODK_USER_ASSIGNMENT");
}

export const deleteOdkForm = (input, clientMutationLabel) => {
  if (!input || !input.odkFormUuid) {
    return;
  }

  // Ensure proper GraphQL mutation structure
  const mutation = `
    mutation {
      deleteOdkForm(input: {
        odkFormUuid: "${input.odkFormUuid}",
        clientMutationId: "${crypto.randomUUID()}",
        clientMutationLabel: "${clientMutationLabel}"
      }) {
        clientMutationId
        internalId
      }
    }
  `;

  return graphql(mutation, ["DELETE_ODK_FORM_REQ", "DELETE_ODK_FORM_RESP", "DELETE_ODK_FORM_ERR"], {
    clientMutationId: crypto.randomUUID(),
    clientMutationLabel,
    odkFormUuid: input.odkFormUuid,
  });
};

export const suspendProject = (uuid, clientMutationLabel = "Suspend Accreditation Project") => {
  const mutation = formatMutation("suspendAccreditationProject", `uuid: "${uuid}"`, clientMutationLabel);

  const requestedDateTime = new Date();

  return graphql(
    mutation.payload,
    ["ACCREDITATION_MUTATION_REQ", "ACCREDITATION_SUSPEND_PROJECT_RESP", "ACCREDITATION_MUTATION_ERR"],
    {
      clientMutationId: mutation.clientMutationId,
      clientMutationLabel,
      requestedDateTime,
    },
  );
};

export const cancelProject = (uuid, clientMutationLabel = "Cancel Accreditation Project") => {
  const mutation = formatMutation("cancelAccreditationProject", `uuid: "${uuid}"`, clientMutationLabel);

  const requestedDateTime = new Date();

  return graphql(
    mutation.payload,
    ["ACCREDITATION_MUTATION_REQ", "ACCREDITATION_CANCEL_PROJECT_RESP", "ACCREDITATION_MUTATION_ERR"],
    {
      clientMutationId: mutation.clientMutationId,
      clientMutationLabel,
      requestedDateTime,
    },
  );
};
